"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OlapicSliderButtons = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _collapseContext = require("../../contexts/collapseContext");
var _models = require("../../models");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const OlapicSliderButtons = ({
  slide,
  activeItem,
  origin,
  maxSlideRange
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isFirst = activeItem < 1;
  const isLast = activeItem > maxSlideRange - 1;
  const {
    onClose
  } = (0, _collapseContext.useCollapseContext)();
  const onClick = (0, _react.useCallback)(direction => () => {
    slide(direction);
    // Close Collapse component when clicking on the slider buttons
    onClose();
  }, [onClose, slide]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LeftButton, {
      "data-testid": getTestId(`${origin}-${_constants.LEFT_BUTTON}`),
      "aria-label": "\u2190",
      color: "default",
      isFirst: isFirst,
      origin: origin,
      size: "large",
      variant: "contained",
      onClick: onClick(_models.SliderDirection.left),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowLeftThin, {
        fontSize: "inherit"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.RightButton, {
      "data-testid": getTestId(`${origin}-${_constants.RIGHT_BUTTON}`),
      "aria-label": "\u2192",
      color: "default",
      isLast: isLast,
      origin: origin,
      size: "large",
      variant: "contained",
      onClick: onClick(_models.SliderDirection.right),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {
        fontSize: "inherit"
      })
    })]
  });
};
exports.OlapicSliderButtons = OlapicSliderButtons;
